import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { Modal, UnitTitleBlock } from 'lib/components';
import { cn } from "lib/utils"
import { Forms } from 'lib/components/forms';
import { 
  build_new_dispute, 
  build_opening_statements, 
  build_compelling_evidence, 
  DISPUTE_TYPES, 
  queryTools 
} from "lib/utils"

const elemConfig = {
  statements: [
    {
      refstr: "",
      title: "",
      description: "",
      visible: true,
      parent: ["[root]"],
      parentResult: "any",
      level: 1,
      if_passes: "content",
      if_fails: "nothing",
      nested: {
        if_passes: null,
        if_fails: null
      },
      conditional: {
        source_id: null,
        name: "",
        description: "",
        zones: [ { "zoneref": "", "groups": [ { "groupref": "", "items": [] } ] } ],
        items: [],
        clipboard: []
      },
      content: {
        pass: "",
        fail: ""
      }
    }
  ]
}

const defaultFormData = {
  Id: 0,
  title: "New Template",
  usage: "generic",
  design: "Def Leppard",
  layout: "Nirvana",
  client: null,
  rp: null,
  subdomain: null,
  generator: "tb3"
}


export default function NewTemplateForm({ 
  action="create",
  initData={ source: null, client: null, rp: null, subdomain: null }, 
  setOpenModal 
} : { 
  action?:string;
  initData?:any; 
  setOpenModal:any 
}){

  // defaultFormData == default for all new disputes 
  // initData == data from the dispute being cloned or needed for a variant

  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {}, { enabled: true })
  const saveDispute = queryTools.resource.save(["dispute"])

  const [ disputeData, setDisputeData ] = useState({...defaultFormData, ...initData})
  const [ missingFields, setMissingFields ] = useState<any>([])
  const [ formMessage, setFormMessage ] = useState<any>(null)

  const messages = {
    missing: "Please fill in all required fields.",
    success: "Dispute template created successfully.",
    error: "There was an error creating the dispute template."
  }


  const validate = () => {
    let required = ["Id", "title", "usage"]
    if( initData.action === "variant" ){
      required = [...required, "rp", "subdomain"]
    } else if( initData.action === "clone" ){
      required = [...required, "client"]
    }
    const missing = required.filter((field) => (!disputeData[field] && disputeData[field] !== 0))
    console.log("missing", missing)
    if( missing.length > 0 ){
      setFormMessage({ type: "error", message: messages.missing })
      setMissingFields(missing)
      return false
    } else {
      setMissingFields([])
      return true
    } 
  }

  const handleFormSave = (e:any) => {
    e.preventDefault()
    const check = validate()
    if( check ){
      const fullDispute = build_new_dispute({ ...disputeData })
      // return console.log(fullDispute)
      saveDispute.mutate({ resource: "dispute", data: fullDispute })
      setOpenModal(false)
    }
  }

  function handleInputChange(e:any){
    setMissingFields([])
    setFormMessage(null)
    if( e.target.name === "Id" ){
      if( e.target.value.length && isNaN(Number(e.target.value)) ){
        return 
      }
    }
    setDisputeData({...disputeData, [e.target.name]: e.target.value})
  }

  useEffect(() => {
    console.log("disputeData", disputeData)
  },[disputeData])

  useEffect(() => {
    console.log(action, initData)
  },[action, initData])

  return (
    <div className="w-10/12 mx-auto flex flex-col">
      <Forms.Form onSubmit={handleFormSave}>

        <div className="w-full flex gap-4">
          <Forms.FieldGroup name="Id" label="Id" type="text" required={true} className="w-2/12">
            <Forms.InputField 
              name="Id" 
              className={cn(
                "h-9 text-sm",
                missingFields.includes("Id") && "border-red-500" 
              )}
              value={disputeData.Id} 
              onChange={handleInputChange} 
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup name="title" label="title" type="text" required={true} className="w-10/12">
            <Forms.InputField 
              name="title" 
              className="h-9 text-sm" 
              value={ initData.action === "clone" 
                  ? `Copy of ${disputeData.title}` 
                  : initData.action === "variant"
                    ? `Variant of ${disputeData.title}`
                    : disputeData.title 
              } 
              onChange={handleInputChange} 
            />
          </Forms.FieldGroup>
        </div>
            

        { initData.action === "variant" && (
          <div className="w-full flex gap-4">
            <Forms.FieldGroup name="rp" label="RP" type="text" required={true} className="w-3/12">
              <Forms.InputField name="rp" className="h-9 text-sm" value={disputeData.rp || ""} onChange={handleInputChange} />
            </Forms.FieldGroup>

            <Forms.FieldGroup name="subdomain" label="Subdomain" type="text" required={true} className="w-9/12">
              <Forms.InputField name="subdomain" className="h-9 text-sm" value={disputeData.subdomain || ""} onChange={handleInputChange} />
            </Forms.FieldGroup>
          </div>
        )}

        <Forms.FieldGroup name="usage" label="usage" type="text">
          <Forms.Select 
            name="usage" 
            className="h-9 text-sm"
            value={disputeData.usage}
            onChange={handleInputChange} 
          >
            <option value="">Choose one...</option>
            { DISPUTE_TYPES.map( (type:any) => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </Forms.Select>
        </Forms.FieldGroup>
        
        { _Clients?.length > 0 && (
          <Forms.FieldGroup name="client" label="Client" type="text">
            <Forms.Select 
              name="client" 
              className="h-9 text-sm"
              value={disputeData.client || ""}
              onChange={handleInputChange} 
            >
              <option value="">[none]</option>
              { _Clients.map( (client:any) => (
                <option key={client._id} value={client._id}>{client.name}</option>
              ))}
            </Forms.Select>
          </Forms.FieldGroup>
        )}

        <div className="w-full flex gap-4">
          <Forms.FieldGroup name="design" label="design" type="text" className="w-6/12">
            <Forms.InputField name="design" className="h-9 text-sm" readOnly={true} value={disputeData.design} />
          </Forms.FieldGroup>

          <Forms.FieldGroup name="layout" label="layout" type="text" className="w-6/12">
            <Forms.InputField name="layout" className="h-9 text-sm" readOnly={true} value={disputeData.layout} />
          </Forms.FieldGroup>
        </div>

        <Forms.FieldGroup className="w-full flex items-end pr-1">
          <Forms.FormButton className="w-8/12 justify-center px-3 uppercase" type="submit">Create Template</Forms.FormButton>
        </Forms.FieldGroup>
      </Forms.Form>

      { formMessage !== null && (
        <div className={cn(
          "w-full flex justify-center items-center text-sm",
          formMessage.type === "error" ? "text-red-500" : "text-green-500",
        )}>
          { formMessage.message }
        </div>
      )}
    </div>
  )
}